import { PersonSummary } from '../../components/avatar';
import { capitalizarPalabras } from '../../common/upperCaseWord';
import { DeviceInfoCell } from './DeviceInfoCell';
import {
    formatDuration,
    formatMexicoDateTime,
} from './usuariosOnline.constants';

const DateTimeCell = ({ value }) => {
    const { date, time } = formatMexicoDateTime(value);
    if (!date && !time) return <span className='text-sm text-slate-400'>—</span>;

    return (
        <div className='flex flex-col'>
            <span className='text-sm font-medium text-slate-800'>{date}</span>
            <span className='text-xs tabular-nums text-slate-500'>{time}</span>
        </div>
    );
};

export const buildUsuariosOnlineHistoryColumns = () => [
    {
        accessorKey: 'userName',
        id: 'userName',
        header: 'Usuario',
        size: 280,
        enableSorting: true,
        cell: ({ row }) => (
            <PersonSummary
                firstName={row.original?.firstName}
                lastName={row.original?.lastName}
                name={row.original?.userName}
                meta={row.original?.email}
                avatarSize='md'
            />
        ),
        meta: {
            label: 'Usuario',
            searchable: true,
            searchPlaceholder: 'Buscar usuario…',
        },
    },
    {
        accessorKey: 'userId',
        id: 'userId',
        header: 'userId',
        size: 220,
        enableSorting: false,
        cell: ({ getValue }) => (
            <span className='font-mono text-xs text-slate-500'>{getValue() || '—'}</span>
        ),
        meta: { label: 'userId' },
    },
    {
        accessorKey: 'typeUser',
        id: 'typeUser',
        header: 'Tipo',
        size: 140,
        enableSorting: true,
        cell: ({ getValue }) => capitalizarPalabras(getValue()),
        meta: { label: 'Tipo' },
    },
    {
        accessorKey: 'deviceType',
        id: 'deviceType',
        header: 'Dispositivo',
        size: 160,
        enableSorting: true,
        cell: ({ row }) => (
            <DeviceInfoCell
                deviceType={row.original?.deviceType}
                os={row.original?.os}
                ip={row.original?.ip}
            />
        ),
        meta: { label: 'Dispositivo' },
    },
    {
        accessorKey: 'connectedAt',
        id: 'connectedAt',
        header: 'Conexión',
        size: 150,
        enableSorting: true,
        cell: ({ getValue }) => <DateTimeCell value={getValue()} />,
        meta: { label: 'Conexión' },
    },
    {
        accessorKey: 'disconnectedAt',
        id: 'disconnectedAt',
        header: 'Desconexión',
        size: 150,
        enableSorting: true,
        cell: ({ getValue, row }) => {
            if (row.original?.status !== 'ended' || !getValue()) {
                return (
                    <span className='inline-flex items-center rounded-md border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-emerald-700'>
                        Activa
                    </span>
                );
            }
            return <DateTimeCell value={getValue()} />;
        },
        meta: { label: 'Desconexión' },
    },
    {
        accessorKey: 'durationMs',
        id: 'durationMs',
        header: 'Duración',
        size: 120,
        enableSorting: false,
        cell: ({ getValue }) => (
            <span className='text-sm tabular-nums text-slate-700'>{formatDuration(getValue())}</span>
        ),
        meta: { label: 'Duración' },
    },
    {
        accessorKey: 'sessionId',
        id: 'sessionId',
        header: 'Sesión',
        size: 220,
        enableSorting: false,
        cell: ({ getValue }) => (
            <span className='font-mono text-xs text-slate-500'>{getValue() || '—'}</span>
        ),
        meta: { label: 'Sesión' },
    },
];
